import { toast } from 'react-toastify';
import { IErrorModel, IPaginatedResponse } from '@core/models/generic.model';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import TransactionStatementsService from 'services/api/transactionStatements.service';

// -------------------------------------------------------------------------

interface ITransactionStatementsState {
    loading: boolean;
    error: IErrorModel | undefined;
    transactionStatements: []
}

const initialState: ITransactionStatementsState = {
    loading: false,
    error: {} as IErrorModel,
    transactionStatements: []
};

// -------------------------------------------------------------------------

export const getTransactionStatementsThunk = createAsyncThunk<
    IPaginatedResponse,
    {
        size: number;
        page: number;
        serialNumber: string;
        ndcCode: string;
        fromDuns: string;
        toDuns: string;
        startDate: string;
        endDate: string;
    },
    { rejectValue: IErrorModel }
>(`/transactionStatements/getTransactionStatements`, async (params, { rejectWithValue }: any) => {
    try {
        const response: any = await TransactionStatementsService.getTraceability(params);
        return response.data
    } catch (err: any) {
        toast.error(err.errorMessage || 'Failed to fetch transaction statements', { autoClose: 5000 });
        return rejectWithValue(err);
    }
});

// -------------------------------------------------------------------------

const transactionStatementsSlice = createSlice({
    name: `transactionStatements`,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Get Transaction Statements
        builder.addCase(getTransactionStatementsThunk.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getTransactionStatementsThunk.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.transactionStatements = action.payload;
        });
        builder.addCase(getTransactionStatementsThunk.rejected, (state, action) => {
            state.loading = false;
            state.transactionStatements = [];
            state.error = action.payload;
        });
    }
});

// -------------------------------------------------------------------------

export default transactionStatementsSlice;
export const transactionStatementsReducer = transactionStatementsSlice.reducer;

